<template>
  <div class="Echarts" style="width: 100%;height:100%;">
    <div :id="'main'+startID" style="width: 100%;height:100%;"></div>
  </div>
</template>

<script>
import echarts from "echarts";
export default {
  props: {
    kechartsData: {
      type: Object,
      required: true
    },
    startID: {
      type: String,
      default: ""
    },
    types: {
      type: Boolean,
      default: ""
    },
    title: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      upColor: "#00da3c",
      downColor: "#ec0000",
      dataCount: 20,
       color: ['#F15A5A', '#9FCFFF', '#FFD96C'],
       quoteData: [], // 时间
      seriesData: [],   // 折线图数据
      legendName: []  //
    };
  },
  methods: {
    optionInit() {
      // this.kechartsData.forEach((item, idx) => {
      //   this.quoteData.push(item.dtDate);
      //   this.legendName.push(item.dbNetValue);
      // });
      if (this.types) {
        this.kechartsData.dataValue.forEach((item, idx) => {
          this.seriesData.push({
            name: item.name,
            itemStyle: {
              color: colors[idx]
            },
            type: "line",
            symbol: "none", // 去掉小圆点
            data: item.value
          });
        });
        this.quoteData = this.kechartsData.tiem;
        this.legendName = this.kechartsData.dataValue.map(item => item.name);
      } else {
        this.legendName = [];
        this.quoteData = this.kechartsData.tiem;
        this.seriesData.push({
          name: this.kechartsData.name,
          type: "line",
          symbol: "none", // 去掉小圆点
          data: this.kechartsData.value
        });
      }
      //  for (var idx = 0; idx <  this.kechartsData.length; idx++) {
      //       this.legendName.push(this.kechartsData[idx][0].wstrName)

      //   }
    },
    echartsInit() {
      this.optionInit();
   var myChart = this.$echarts.init(
        document.getElementById("main" + this.startID)
      );
      let option = {
        title: {
          text: this.title
        },
        tooltip: {
          trigger: "axis"
        },
        legend: {
          data: this.legendName //["邮件营销", "联盟广告", "视频广告", "直接访问", "搜索引擎"]
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          boundaryGap: ['20%', '20%'],
          data: this.quoteData
        },
        yAxis: {
          type: "value"
        },
        series: this.seriesData
        // [
        //   {
        //     name: "邮件营销",
        //     type: "bar",
        //     stack: "总量",
        //     data: [120, 132, 101, 134, 90, 230, 210]
        //   },
        //   {
        //     name: "联盟广告",
        //     type: "bar",
        //     stack: "总量",
        //     data: [220, 182, 191, 234, 290, 330, 310]
        //   },
        //   {
        //     name: "视频广告",
        //     type: "bar",
        //     stack: "总量",
        //     data: [150, 232, 201, 154, 190, 330, 410]
        //   },
        //   {
        //     name: "直接访问",
        //     type: "bar",
        //     stack: "总量",
        //     data: [320, 332, 301, 334, 390, 330, 320]
        //   },
        //   {
        //     name: "搜索引擎",
        //     type: "bar",
        //     stack: "总量",
        //     data: [820, 932, 901, 934, 1290, 1330, 1320]
        //   }
        // ]
      };

      // 使用刚指定的配置项和数据显示图表。
      myChart.setOption(option);
    }
    // myChartZoom() {
    //   const myChart = this.$echarts.init(document.getElementById("main"));
    //   const than = this;
    //   myChart.on("datazoom", function(params) {
    //     than.$emit("onZoomInit", params);
    //   });
    // }
  },
  mounted() {
    // this.echartsInit();
    // this.myChartZoom();
    window.addEventListener("resize", () => {
      this.$echarts.init(document.getElementById("main")).resize();
    });
  }
};
</script>
<style lang="less" scoped>
.Echarts {
  margin: 20px 0;
}
</style>
